import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'

export default ({ children }) => (
  <Fragment>
    <Heading small compact>
      No Matching CCS Government Enrolments
    </Heading>
    We could not find any ccs government enrolments attached to this care enrolment
    <div className="enrolmentsEmpty--addEnrolmentAction">{children}</div>
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/view/empty.jsx